
























































































































































import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

import InfoButton from '@/components/InfoButton.vue'
import moment from 'moment'

@Component({
	components: {
		InfoButton
	}
})
export default class Results extends GlobalMixins {
	openedBranches: string[] = []
	shownBranches: string[] = []
	showRest: boolean = false
	resultsLoaded: boolean = false

	get userHasSelectedBranches(): boolean {
		return this.branches(true).length > 0
	}

	@Watch('shownBranches', {deep: true})
	onShownBranchesChange(): void {
		if (this.shownBranches.length === (this.branches(true).length + this.branches(false).length)) {
			setTimeout(() => {
				this.showRest = true
			}, 250)
		}
	}

	branches(isSelected: boolean): any {
		let branches = this.$store.getters.branches
		const user = this.$store.getters.user

		branches = [...branches].map((branch: any, index: number) => {
			let relevantCrime = false
			let lookbackWindow = 0

			;[...branch.relevantCrimes].forEach((crime: any) => {
				if (crime.name === user.selectedCrime) {
					relevantCrime = true
					lookbackWindow = crime.window[user.age]
				}
			})
			
			return {
				name: branch.name,
				title: branch.title[this.language],
				icon: branch.icon,
				jobExamples: branch.jobExamples[this.language],
				stars: relevantCrime ? user.selectedCrime === 'sex-offense' ? 1 : this.getPossibillity(lookbackWindow, user, 'stars') : 3,
				nextChance: relevantCrime ? user.selectedCrime === 'sex-offense' ? {} : this.getPossibillity(lookbackWindow, user, 'dates') : {},
				selected: (user.preferredBranches && user.preferredBranches !== 'skipped') ? user.preferredBranches.indexOf(encodeURI(branch.name)) !== -1 ? true : false : false
			}
		})

		branches = [...branches].sort((a: any, b: any): number => {
			if (a.stars === b.stars) {
				return 0
			} else {
				return (b.stars - a.stars)
			}
		})

		branches = [...branches].filter((branch: any) => {
			return branch.selected === isSelected
		})

		return branches
	}
	getPossibillity(lookbackWindow: number, user: any, type: 'stars' | 'dates'): number | any {
		moment.locale(this.language)

		const currentDate = moment()
		const startDate = moment('19000101', 'YYYYMMDD')
		let crimeDate = undefined

		if (user.punishmentWhen === 'skipped') {
			crimeDate = moment([user.crimeWhen.year, (user.crimeWhen.month - 1), user.crimeWhen.day])
		} else {
			crimeDate = moment([user.punishmentWhen.year, (user.punishmentWhen.month - 1), user.punishmentWhen.day])
		}

		const diffCrime = startDate.diff(crimeDate)
		const diffCurent = startDate.diff(startDate)
		const passedTime = diffCurent - diffCrime

		function windowByKeys(): { years: number, months?: number, weeks?: number, days?: number } {
			if (user.punishmentWhen === 'skipped') {
				return {
					years: lookbackWindow
				}
			} else {
				if (user.punishmentLength.timeNotation === 'years') {
					return {
						years: (lookbackWindow + JSON.parse(user.punishmentLength.amount))
					}
				} else {
					const window: { years: number, months?: number, weeks?: number, days?: number } = {
						years: lookbackWindow
					}

					window[(<'days' | 'weeks' | 'months'>user.punishmentLength.timeNotation)] = JSON.parse(user.punishmentLength.amount)

					return window
				}
			}
		}

		let crimePassedDate = crimeDate.clone()
		
		for (const [key, value] of Object.entries(windowByKeys())) {
			crimePassedDate.add(value, (<'days' | 'weeks' | 'months'>key))
		}

		const windowByDate = {
			full: crimePassedDate.add(1, 'day'),
			triquarter: crimeDate.clone().add(crimePassedDate.diff(crimeDate) * .75, 'ms').add(1, 'day'),
			half: crimeDate.clone().add(crimePassedDate.diff(crimeDate) / 2, 'ms').add(1, 'day')
		}
		const windowPassedLength = {
			full: currentDate.diff(windowByDate.full) >= 0,
			triquarter: currentDate.diff(windowByDate.triquarter) >= 0,
			half: currentDate.diff(windowByDate.half) >= 0,
		}

		if (windowPassedLength.full) {
			if (type === 'stars') {
				return 3
			} else {
				return {}
			}
		} else {
			if (user.punishmentWhen === 'skipped') {
				if (user.age === '23+' ? windowPassedLength.triquarter : windowPassedLength.half) {
					if (type === 'stars') {
						return 2
					} else {
						return {
							high: windowByDate.full.format('D MMMM YYYY')
						}
					}
				} else {
					if (type === 'stars') {
						return 1
					} else {
						return {
							medium: user.age === '23+' ? windowByDate.triquarter.format('D MMMM YYYY') : windowByDate.half.format('D MMMM YYYY'),
							high: windowByDate.full.format('D MMMM YYYY')
						}
					}
				}
			} else {
				let shortSentence = false

				switch(user.punishmentLength.timeNotation) {
					case 'days':
						shortSentence = !(user.punishmentLength.amount > 31)
						break
					case 'weeks':
						shortSentence = !(user.punishmentLength.amount > 4)
						break
					case 'months':
						shortSentence = !(user.punishmentLength.amount > 1)
						break
					default:
						shortSentence = false
						break
				}

				if (user.age === '<23' && shortSentence) {
					if (windowPassedLength.triquarter) {
						if (type === 'stars') {
							return 2
						} else {
							return {
								high: windowByDate.full.format('D MMMM YYYY')
							}
						}
					} else {
						if (type === 'stars') {
							return 1
						} else {
							return {
								medium: windowByDate.triquarter.format('D MMMM YYYY'),
								high: windowByDate.full.format('D MMMM YYYY')
							}
						}
					}
				} else {
					if (type === 'stars') {
						return 1
					} else {
						return {
							high: windowByDate.full.format('D MMMM YYYY')
						}
					}
				}
			}
		}
	}
	getMonthName(month: number): string {
		let monthByString = ''
		
		switch(month) {
			case 1:
			case 13:
				monthByString = 'januari'
				break
			case 2:
			case 14:
				monthByString = 'februari'
				break
			case 3:
				monthByString = 'maart'
				break
			case 4:
				monthByString = 'april'
				break
			case 5:
				monthByString = 'mei'
				break
			case 6:
				monthByString = 'juni'
				break
			case 7:
				monthByString = 'juli'
				break
			case 8:
				monthByString = 'augustus'
				break
			case 9:
				monthByString = 'september'
				break
			case 10:
				monthByString = 'oktober'
				break
			case 11:
				monthByString = 'november'
				break
			case 12:
				monthByString = 'december'
				break
		}

		return monthByString
	}
	toggleBranch(branchName: string): void {
		if (this.openedBranches.indexOf(branchName) !== -1) {
			this.openedBranches.splice(this.openedBranches.indexOf(branchName), 1)
		} else {
			this.openedBranches.push(branchName)
		}
	}
	resetApp(): void {
		this.$router.push({ name: this.language === Languages.NL ? 'select-age' : 'select-age-'+this.language })

		setTimeout(() => {
			this.$store.dispatch('resetUser')
		}, 400)
	}

	getFormattedChanceExplanationText(stars: number): string {
		let phrase = this.pageTexts.results.chanceExplanation;
		const chanceLevel = stars === 3 ? this.pageTexts.results.chanceWordHighSeparate : stars === 2 ? this.pageTexts.results.chanceWordMediumSeparate : this.pageTexts.results.chanceWordLowSeparate;
		phrase = phrase.replace('{{ chance-level }}', chanceLevel.toLowerCase());
		return phrase;
	}

	getFormattedNextChancesText(key: string, chance: string): string {
		let phrase = this.pageTexts.results.nextChances;
		const chanceLevel = key === 'high' ? this.pageTexts.results.chanceWordHighSeparate : this.pageTexts.results.chanceWordMediumSeparate;
		phrase = phrase.replace('{{ chance-level }}', chanceLevel.toLowerCase());
		phrase = phrase.replace('{{ chance-date }}', chance);
		return phrase;
	}

	@Watch('language', { immediate: true })
	onLanguageChange() {
		bus.$emit('setNextButton', {label: this.pageTexts.results.nextButton})
	}

	mounted() {
		bus.$emit('setPreviousButton', 'start')

		bus.$on('goToNextScreen', () => {
			const win = window.open('https://www.justis.nl/producten/vog/vog-aanvragen/index.aspx', '_blank')

			if (win) { win.focus() }
		})

		if (this.userHasSelectedBranches) {
			;[...this.branches(true)].forEach((branch: any) => {
				_paq.push(['trackEvent', 'keuzeBranch', branch.title])
			})
		}
		
		setTimeout(() => {
			this.resultsLoaded = true
			
			this.$store.dispatch('trackResults')
		}, 250)

		Vue.nextTick(() => {
			const vm = this

			function openNormalBranches() {
				[...vm.branches(false)].forEach((branch: any, index: number) => {
					setTimeout(() => {
						vm.shownBranches.push(encodeURI(branch.name))
					}, 250 * (index + 1))
				})
			}

			if (this.branches(true).length > 0) {
				[...this.branches(true)].forEach((branch: any, index: number) => {
					setTimeout(() => {
						this.shownBranches.push(encodeURI(branch.name))

						if (this.shownBranches.length === this.branches(true).length) {
							openNormalBranches()
						}
					}, 250 * (index + 1))
				})
			} else {
				openNormalBranches()
			}
		})
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
	}
}
